export const getActiveMonth = date => new Date(date).getMonth() + 1;
export const getActiveYear = date => new Date(date).getFullYear();

export const formatSelectedMonth = selectedMonth => {
  if (selectedMonth < 10) {
    return `0${selectedMonth.toString()}`;
  }
  return selectedMonth.toString();
};

/**
 * @typedef DateRangeProps
 * @property {Date} value
 * @property {string} day
 * @property {string} month
 * @property {string} [year]
 */

/**
 * @function dateRangeIntlProps
 * @param {Date} start
 * @param {Date} [end]
 * @returns {{startProps: DateRangeProps, endProps?: DateRangeProps}}
 */
export const dateRangeIntlProps = (start, end) => {
  const props = date => ({
    value: date,
    day: '2-digit',
    month: '2-digit',
  });
  const returnPayload = {
    startProps: { ...props(start) },
  };

  // if end date exists, give it props
  if (end) {
    returnPayload.endProps = { ...props(end), year: '2-digit' };
    // if start and end years not the same, make sure start date shows year
    if (start.getFullYear() !== end.getFullYear()) {
      returnPayload.startProps = {
        ...returnPayload.startProps,
        year: '2-digit',
      };
    }
  }

  return returnPayload;
};
